// extracted by mini-css-extract-plugin
export default {"modal":"AR-z","sharingIconsV2":"BR-z","notificationBox":"CR-z","checkMark":"DR-z","textFrame":"ER-z"};